import React from 'react';
import Forward from '@material-ui/icons/Forward';
import Reply from '@material-ui/icons/Reply';
import ReplyAll from '@material-ui/icons/ReplyAll';
import { MESSAGEBOX_TYPES } from 'src/constants/constants';

export default function MessageDetailsActionsPres({
  isApplicant,
  isCaseMessages,
  messageData,
  onReply,
  onReplyToAll,
  onForward,
  selectedMenu,
}) {
  const messagesActions = (
    <nav className="nav-bar" aria-label="Message Options">
      <button className="msg-action-button" aria-label="Reply to Message" onClick={onReply}>
        <Reply className="icon md" />
      </button>
      <button className="msg-action-button" aria-label="Reply to all Message" onClick={onReplyToAll}>
        <ReplyAll className="icon md" />
      </button>
      <button className="msg-action-button" aria-label="Forward Message" onClick={onForward}>
        <Forward className="icon md" />
      </button>
    </nav>
  );

  if (isCaseMessages) {
    if (selectedMenu !== MESSAGEBOX_TYPES.DRAFT && isApplicant) {
      return messageData.isReceiver || (messageData.isSender && messagesActions);
    } else if (selectedMenu !== MESSAGEBOX_TYPES.DRAFT) {
      return messagesActions;
    }
  }

  return messagesActions;
}
